import { render, staticRenderFns } from "./ReferFriendModal.vue?vue&type=template&id=12e2edce&"
import script from "./ReferFriendModal.vue?vue&type=script&lang=ts&"
export * from "./ReferFriendModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports